/* rk-quickadd.js (round 54, R3, 15 Oct 2026). The shared quick add component (DESIGN.md 8.4, 9.1, 10.4, 11).
   Used by the "Pairs well with" row on product pages (sections/bf27-bundle-strip.liquid) and the cart drawer row (snippets/rk-qa-drawer.liquid);
   markup from snippets/rk-qa-row.liquid + rk-qa-card.liquid, styles in assets/rk-quickadd.css. Loaded by those two files (and sections/cart-drawer.liquid), not theme.liquid.
   1 Rows: sideways scroll; the small round arrows (Shrine slider style) scroll by one card and hide at the ends; no arrows when everything fits.
   2 Families: a row never offers a family that is in the cart (rules: snippets/rk-qa-family.liquid, printed on the row as data-rules), nor this page's own
     family, gifts never. First paint is Liquid. After every cart request (/cart/add|change|update|clear, seen through PerformanceObserver, so no fetch wrapper)
     the cart is read once from /cart.js and every row is updated; a row rendered after that read started is left alone (it is newer). Fewer than 2 cards = row hidden.
   3 Pop-out: Add opens a small dialog (bottom sheet under 750px, popover above) with the colour swatches (the product page's colours, from rk-qa-colour.liquid)
     and the size pills when the product has a size. Focus is trapped, Esc / the X / a tap outside close it, focus returns to the Add button.
     A product with nothing to choose is added straight away.
   4 Add: one POST /cart/add.js with the cart drawer's own sections (Section Rendering API), then the theme's cart-drawer renderContents() + open():
     the drawer refreshes, the header count bubble updates, and the round 53 gift sync (assets/bf26y-giftguard.js) sees the request as it sees every theme add.
   Rollback: git revert of the r54 quick add commits. */
(function () {
  'use strict';
  if (window.RKQA) return;
  var doc = document;
  var MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var X_FALLBACK = '<svg class="rk-icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function xIcon() { var t = doc.querySelector('template[data-rkqa-icon-close]'); return (t && t.innerHTML.trim()) || X_FALLBACK; } // rk-icon 'close' (snippets/rk-icon.liquid)

  function $$(s, r) { return [].slice.call((r || doc).querySelectorAll(s)); }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.split(' - ')[0].replace(/\s+/g, ' ').trim();
  }
  function data(card) {
    if (card.__rkqaD === undefined) {
      try { card.__rkqaD = JSON.parse(card.querySelector('[data-rkqa-data]').textContent); } catch (e) { card.__rkqaD = null; }
    }
    return card.__rkqaD;
  }
  function rowsAll() { return $$('[data-rkqa-row]'); }
  function cardsOf(row) { return $$('[data-rkqa-card]', row); }
  function labels(row) {
    var g = function (k, d) { return (row && row.getAttribute('data-l-' + k)) || d; };
    return { add: g('add', 'Add to cart'), adding: g('adding', 'Adding'), added: g('added', 'Added to your cart'), error: g('error', 'Sorry, we could not add that. Please try again.'), group: g('group', '[option] for [name]') };
  }
  var live = null;
  function say(t) {
    if (!live) { live = doc.createElement('p'); live.className = 'rkqa-sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); doc.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60);
  }

  /* ---------- 2 families ---------- */
  var RULES = null;
  function loadRules(row) {
    if (RULES) return;
    var s = row && row.getAttribute('data-rules'); if (!s) return;
    RULES = s.split(',').map(function (r) { var p = r.split('>'); return [p[0], p[1] || p[0]]; }).filter(function (p) { return p[0]; });
  }
  function famOf(handle) {
    handle = String(handle || '');
    var R = RULES || [];
    for (var i = 0; i < R.length; i++) if (handle.indexOf(R[i][0]) > -1) return R[i][1].split('+');
    return [handle];
  }
  function cartFams(cart) {
    var f = {};
    ((cart && cart.items) || []).forEach(function (it) { famOf(it.handle).forEach(function (x) { if (x) f[x] = 1; }); });
    return f;
  }
  function apply(row, fams) {
    var self = (row.getAttribute('data-self') || '').split('+').filter(Boolean), shown = 0;
    cardsOf(row).forEach(function (c) {
      var hide = false;
      (c.getAttribute('data-family') || '').split('+').forEach(function (x) { if (x === 'gift' || fams[x] || self.indexOf(x) > -1) hide = true; });
      if (c.hidden !== hide) c.hidden = hide;
      if (!hide) shown++;
    });
    var off = shown < 2;
    if (row.hidden !== off) row.hidden = off;
    row.setAttribute('data-cart', Object.keys(fams).join(' '));
    arrows(row);
  }

  var seq = 0, lastRead = null;
  function cartUrl() {
    var r = doc.querySelector('[data-rkqa-row][data-cart-url]');
    var u = (r && r.getAttribute('data-cart-url')) || (window.routes && window.routes.cart_url) || '/cart';
    return u.replace(/\/$/, '') + '.js';
  }
  function refresh() {
    var t0 = now(), my = ++seq;
    fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        if (my !== seq) return; // a newer read is on its way
        var f = cartFams(cart);
        lastRead = { t: t0, f: f };
        rowsAll().forEach(function (row) { if (row.__rkqa && row.__rkqa.t <= t0) apply(row, f); });
      })
      .catch(function () {});
  }
  var soonT = 0;
  function soon() { clearTimeout(soonT); soonT = setTimeout(refresh, 350); }
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        var u = e.name || '';
        try { u = new URL(u, location.href).pathname; } catch (x) {}
        if (MUT.test(u)) soon();
      });
    }).observe({ type: 'resource', buffered: true }); // buffered: a cart change made before this script loaded also triggers one read
  } catch (e) {}
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* ---------- 1 rows and arrows ---------- */
  function trackOf(row) { return row.querySelector('[data-rkqa-track]'); }
  function stepOf(row) {
    var t = trackOf(row), c = cardsOf(row).filter(function (x) { return !x.hidden; })[0];
    if (!c) return t.clientWidth;
    var gap = parseFloat(getComputedStyle(t).columnGap) || 0;
    return c.getBoundingClientRect().width + gap;
  }
  function setArrow(b, on, other) {
    if (!b) return;
    if (!on && doc.activeElement === b && other && !other.hidden) other.focus({ preventScroll: true });
    b.hidden = !on; b.disabled = !on;
  }
  function arrows(row, to) {
    var t = trackOf(row), p = row.querySelector('[data-rkqa-prev]'), n = row.querySelector('[data-rkqa-next]');
    if (!t || !p || !n) return;
    var max = t.scrollWidth - t.clientWidth, x = to == null ? Math.abs(t.scrollLeft) : to, over = !row.hidden && max > 2;
    setArrow(p, over && x > 2, n);
    setArrow(n, over && x < max - 2, p);
  }
  function scrollRow(row, dir) {
    var t = trackOf(row); if (!t) return;
    var rtl = getComputedStyle(t).direction === 'rtl' ? -1 : 1, d = stepOf(row), max = t.scrollWidth - t.clientWidth;
    t.scrollBy({ left: dir * rtl * d, behavior: reduce ? 'auto' : 'smooth' });
    var to = Math.max(0, Math.min(max, Math.abs(t.scrollLeft) + dir * d));
    row.__rkqaTo = { x: to, until: now() + 700 }; // while the smooth scroll runs, the arrows keep the end state (no flicker)
    arrows(row, to);
  }
  function register(row) {
    var e = window.bf26gLadder; if (!e || !e.registerVariants) return;
    var ids = [];
    cardsOf(row).forEach(function (c) { var d = data(c); if (d && d.l) d.x.forEach(function (v) { ids.push(v.id); }); });
    if (ids.length) { try { e.registerVariants(ids); } catch (x) {} }
  }
  function initRow(row, first) {
    if (row.__rkqa) return;
    row.__rkqa = { t: first ? 0 : now() }; // when this row's HTML was rendered: page rows with the page, drawer rows when they were swapped in
    loadRules(row);
    var t = trackOf(row);
    if (t) t.addEventListener('scroll', function () {
      if (row.__rkqaTm) return;
      row.__rkqaTm = setTimeout(function () {
        row.__rkqaTm = 0;
        var g = row.__rkqaTo, x = Math.abs(t.scrollLeft);
        if (g && now() < g.until && Math.abs(x - g.x) > 2) return;
        row.__rkqaTo = null;
        arrows(row);
      }, 60);
    }, { passive: true });
    if (lastRead && lastRead.t >= row.__rkqa.t) apply(row, lastRead.f);
    arrows(row);
    register(row);
    if (row.getAttribute('data-ctx') === 'pdp') follow(row);
  }
  function scan(first) { rowsAll().forEach(function (r) { initRow(r, first); }); }
  var scanT = 0;
  function scanSoon() { clearTimeout(scanT); scanT = setTimeout(function () { scan(); rowsAll().forEach(arrows); }, 40); }
  window.addEventListener('resize', function () { rowsAll().forEach(arrows); if (P) place(); });
  window.addEventListener('load', function () { rowsAll().forEach(function (r) { register(r); arrows(r); }); });

  /* ---------- product page: follow the colour picked on this page ("Preselect the colour picked on this page") ---------- */
  function swapRules(s) {
    var R = {};
    String(s || '').split('\n').forEach(function (l) {
      var i = l.indexOf('='); if (i < 1) return;
      var a = l.slice(0, i).split(':'); if (a.length < 2) return;
      R[norm(a[0]) + '|' + norm(a[1])] = l.slice(i + 1).split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    });
    return R;
  }
  /* 22 Oct 2026 (Alexander): a partner shows only in the same colour or a true equivalent (Rosé = Pink, Mint = Green), never a nearest-colour
     fallback; no match = the card is hidden (data-rk-nocol) and the row hides when fewer than two cards are left. Same families in sections/bf27-bundle-strip.liquid. */
  function fam(c) { c = norm(c); return (c === 'rose' || c === 'pink') ? 'rose' : (c === 'mint' || c === 'green') ? 'mint' : c; }
  function pickColour(d, colour) {
    var k = norm(colour), f = fam(colour), hit = null;
    d.x.forEach(function (v) { if (!hit && v.a && norm(v.o[d.ci]) === k) hit = v; });
    if (!hit) d.x.forEach(function (v) { if (!hit && v.a && fam(v.o[d.ci]) === f) hit = v; });
    return hit;
  }
  function rowShow(row) {
    var n = cardsOf(row).filter(function (c) { return !c.hidden && !c.hasAttribute('data-rk-nocol'); }).length;
    if (row.hasAttribute('data-rk-colrow')) row.hidden = n < 2;
  }
  function setPref(card, v) {
    var b = card.querySelector('[data-rkqa-add]'), pr = card.querySelector('[data-rkqa-price]'), im = card.querySelector('[data-rkqa-img]');
    if (b) b.setAttribute('data-variant', v.id);
    if (pr && pr.innerHTML !== v.p) pr.innerHTML = v.p;
    if (im && v.i) { im.src = v.i; im.hidden = false; }
  }
  function follow(row) {
    var el = doc.querySelector('[data-rkqa-main="' + row.id + '"]'), M;
    try { M = JSON.parse(el.textContent); } catch (e) { return; }
    if (!M || M.ci < 0 || !M.variants || !M.variants.length) return;
    var R = swapRules(M.rules), last = null;
    function colourOf(id) {
      id = parseInt(id, 10);
      for (var i = 0; i < M.variants.length; i++) if (M.variants[i].id === id) return String(M.variants[i].o[M.ci] || '').split(' - ')[0];
      return null;
    }
    // 21 Oct 2026: pack pages (3 Pack default) pick colours in per-slot dropdowns that never change the main variant,
    // so the colour just picked anywhere in the buy box (slot dropdown or swatch) wins; the main variant is the fallback.
    var colours = {};
    M.variants.forEach(function (v) { var k = String(v.o[M.ci] || '').split(' - ')[0]; if (k) colours[norm(k)] = k; });
    var lastIn; // the main variant's colour at the last look: the fallback only acts when that colour itself changes
    function go(picked) {
      var c = picked ? colours[norm(picked)] : null;
      if (!c) {
        var input = mainInput(); if (!input) return;
        var cin = colourOf(input.value);
        if (cin === lastIn) return; // unchanged (or another product's id, e.g. the SoftClip 2-Pack): keep the picked colour
        lastIn = cin; c = cin;
      }
      if (!c || c === last) return;
      if (last === null) { last = c; return; } // first paint is already right (Liquid)
      last = c;
      // 26 Oct 2026: partners marked Backup (data-rk-backup, sections/bf27-bundle-strip.liquid) only fill in when fewer than two other cards have this colour
      var all = cardsOf(row), n = 0;
      all.filter(function (card) { return !card.hasAttribute('data-rk-backup'); }).forEach(function (card) {
        var d = data(card);
        if (d && d.m && d.ci > -1) {
          var v = pickColour(d, c);
          if (v) { setPref(card, v); card.removeAttribute('data-rk-nocol'); } else card.setAttribute('data-rk-nocol', '');
        }
        if (!card.hidden && !card.hasAttribute('data-rk-nocol')) n++;
      });
      all.filter(function (card) { return card.hasAttribute('data-rk-backup'); }).forEach(function (card) {
        var d = data(card), v = (n < 2 && !card.hidden && d && d.ci > -1) ? (d.m ? pickColour(d, c) : true) : null;
        if (v) { if (v !== true) setPref(card, v); card.removeAttribute('data-rk-nocol'); n++; } else card.setAttribute('data-rk-nocol', '');
      });
      rowShow(row);
    }
    go();
    doc.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && (t.closest('[data-rkqa-row]') || t.closest('.rkqa-pop') || t.closest('cart-drawer'))) return;
      var picked = t && /^options\[|colou?r/i.test(t.name || '') ? t.value : null; // Shrine options, pack slots, the SoftClip picker (rk-sc-colour-*)
      if (picked && colours[norm(picked)]) { go(picked); return; }
      if (t && t.name === 'id' && colourOf(t.value)) { lastIn = colourOf(t.value); go(lastIn); return; } // the id that changed, not the first one on the page (SoftClip has two)
      setTimeout(go, 80); setTimeout(go, 700); // the main variant input can update after Shrine's section fetch
    }, true);
  }
  function mainInput() {
    var list = $$('product-form[data-main="true"] [name="id"], form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < list.length; i++) if (!list[i].closest('cart-drawer, .rkqa, .rkqa-pop')) return list[i];
    return null;
  }

  /* ---------- 3 pop-out ---------- */
  var P = null, uid = 0, swallowEsc = false;
  function variantFor(d, sel) {
    for (var i = 0; i < d.x.length; i++) {
      var v = d.x[i], ok = true;
      for (var k = 0; k < sel.length; k++) if (v.o[k] !== sel[k]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function byId(d, id) { for (var i = 0; i < d.x.length; i++) if (d.x[i].id === id) return d.x[i]; return null; }
  function valueOk(d, sel, i, val) {
    // colour: any variant of that colour in stock; another option: in stock with the chosen colour
    return d.x.some(function (v) {
      if (!v.a || v.o[i] !== val) return false;
      if (d.ci > -1 && i !== d.ci && v.o[d.ci] !== sel[d.ci]) return false;
      return true;
    });
  }
  function choose(d, sel, i, val) {
    var s = sel.slice(); s[i] = val;
    var v = variantFor(d, s);
    if (v && v.a) return s;
    var best = null, bestN = -1;
    d.x.forEach(function (x) {
      if (!x.a || x.o[i] !== val) return;
      var n = 0; for (var k = 0; k < s.length; k++) if (x.o[k] === s[k]) n++;
      if (n > bestN) { best = x; bestN = n; }
    });
    return best ? best.o.slice() : s;
  }
  function popHTML(d, row, id) {
    var L = labels(row);
    var h = '<div class="rkqa-pop__scrim" data-rkqa-x></div>' +
      '<div class="rkqa-pop__panel" role="dialog" aria-modal="true" aria-labelledby="' + id + '-t" tabindex="-1">' +
      '<div class="rkqa-pop__head">' +
      '<span class="rkqa-pop__media"><img class="rkqa-pop__img" alt="" width="64" height="64" data-rkqa-pimg></span>' +
      '<div class="rkqa-pop__info"><p class="rkqa-pop__title" id="' + id + '-t">' + esc(d.t) + '</p><p class="rkqa-pop__amt" data-rkqa-pprice></p></div>' +
      '<button type="button" class="rkqa-pop__close" data-rkqa-x aria-label="Close">' + xIcon() + '</button>' +
      '</div>';
    d.o.forEach(function (o, i) {
      if (!o.v || o.v.length < 2) return;
      var gl = (o.c || L.group.indexOf('[option]') > -1) ? L.group : '[option] for [name]'; // an old "Colour for [name]" label is used for the colour group only
      gl = gl.replace('[option]', o.n).replace('[name]', d.t);
      h += '<fieldset class="rkqa-pop__opt rkqa-pop__opt--' + (o.c ? 'colour' : 'pill') + '" data-rkqa-opt="' + i + '">' +
        '<legend class="rkqa-pop__legend"><span class="rkqa-sr">' + esc(gl) + '</span><span aria-hidden="true"><span class="rkqa-pop__val" data-rkqa-val></span></span></legend>' +
        '<div class="rkqa-pop__vals">';
      o.v.forEach(function (val, j) {
        var vid = id + '-' + i + '-' + j, nm = id + '-o' + i;
        if (o.c) {
          h += '<label class="rkqa-sw" for="' + vid + '"><input class="rkqa-sw__in rkqa-sr-in" type="radio" id="' + vid + '" name="' + nm + '" value="' + esc(val.v) + '" data-i="' + i + '">' +
            '<span class="rkqa-sw__chip" style="background: ' + esc(val.b || 'transparent') + ';"></span><span class="rkqa-sr" data-rkqa-name>' + esc(val.v) + '</span></label>';
        } else {
          h += '<label class="rkqa-pill" for="' + vid + '"><input class="rkqa-pill__in rkqa-sr-in" type="radio" id="' + vid + '" name="' + nm + '" value="' + esc(val.v) + '" data-i="' + i + '">' +
            '<span class="rkqa-pill__t">' + esc(val.v) + '</span></label>';
        }
      });
      h += '</div></fieldset>';
    });
    h += '<p class="rkqa-pop__msg" role="alert" data-rkqa-msg></p>' +
      '<button type="button" class="rkqa-pop__add" data-rkqa-go>' + esc(L.add) + '</button>' +
      '</div>';
    return h;
  }
  function paint() {
    if (!P) return;
    var d = P.d, sel = P.sel, v = variantFor(d, sel);
    $$('input[type="radio"]', P.panel).forEach(function (inp) {
      var i = +inp.getAttribute('data-i'), ok = valueOk(d, sel, i, inp.value);
      inp.checked = sel[i] === inp.value;
      inp.disabled = !ok && !inp.checked;
      inp.closest('label').classList.toggle('is-out', !ok);
      var nm = inp.closest('label').querySelector('[data-rkqa-name]');
      if (nm) nm.textContent = inp.value + (ok ? '' : ', sold out');
    });
    $$('[data-rkqa-opt]', P.panel).forEach(function (fs) { var i = +fs.getAttribute('data-rkqa-opt'), o = fs.querySelector('[data-rkqa-val]'); if (o) o.textContent = sel[i]; });
    var pr = P.panel.querySelector('[data-rkqa-pprice]'), im = P.panel.querySelector('[data-rkqa-pimg]'), go = P.panel.querySelector('[data-rkqa-go]');
    if (pr) pr.innerHTML = v ? v.p : '';
    var src = (v && v.i) || P.img;
    if (im) { if (src) { im.src = src; im.hidden = false; } else im.hidden = true; }
    if (go && !P.busy) { go.disabled = !(v && v.a); }
    P.v = v;
  }
  function place() {
    if (!P) return;
    var desk = !!(window.matchMedia && matchMedia('(min-width: 750px)').matches), panel = P.panel;
    P.root.classList.toggle('rkqa-pop--sheet', !desk);
    P.root.classList.toggle('rkqa-pop--float', desk);
    if (!desk) { panel.style.top = ''; panel.style.left = ''; return; }
    var r = P.btn && P.btn.isConnected ? P.btn.getBoundingClientRect() : P.rect;
    if (!r) return;
    P.rect = r;
    var w = panel.offsetWidth, h = panel.offsetHeight, vw = doc.documentElement.clientWidth, vh = window.innerHeight, m = 12;
    var top = r.bottom + 8;
    if (top + h > vh - m) top = r.top - 8 - h;
    top = Math.max(m, Math.min(top, vh - m - h)); // always inside the viewport
    var left = Math.max(m, Math.min(r.left + r.width / 2 - w / 2, vw - m - w));
    panel.style.top = Math.round(top) + 'px';
    panel.style.left = Math.round(left) + 'px';
  }
  function tabbables() {
    if (!P) return [];
    return $$('button:not([disabled]), input[type="radio"]:checked:not([disabled]), a[href]', P.panel).filter(function (el) { return !el.hidden && el.offsetParent !== null; });
  }
  function onScroll() { if (P && !P.raf) P.raf = setTimeout(function () { if (P) { P.raf = 0; place(); } }, 30); }
  function openPop(card, btn) {
    var d = data(card), row = card.closest('[data-rkqa-row]');
    if (!d || !row) return;
    var startId = parseInt(btn.getAttribute('data-variant'), 10) || d.pref;
    var choice = d.o.some(function (o) { return o.v && o.v.length > 1; });
    if (!choice) { addVariant(startId, row, btn); return; }
    closePop(true);
    var start = byId(d, startId);
    if (!start || !start.a) start = d.x.filter(function (v) { return v.a; })[0] || d.x[0];
    var id = 'rkqa-p' + (++uid), root = doc.createElement('div');
    root.className = 'rkqa-pop rkqa-pop--' + (row.getAttribute('data-ctx') || 'pdp');
    root.innerHTML = popHTML(d, row, id);
    var im = card.querySelector('[data-rkqa-img]');
    P = { root: root, panel: root.querySelector('.rkqa-pop__panel'), d: d, row: row, card: card, btn: btn, handle: d.h, sel: start.o.slice(), img: im && im.getAttribute('src'), busy: false, rect: null, raf: 0 };
    doc.body.appendChild(root);
    paint();
    place();
    if (!P.root.classList.contains('rkqa-pop--float')) doc.documentElement.classList.add('rkqa-lock');
    btn.setAttribute('aria-expanded', 'true');
    void root.offsetWidth; // the closed state is laid out, so the sheet / popover transition runs
    root.classList.add('is-open');
    var first = P.panel.querySelector('input[type="radio"]:checked') || P.panel;
    try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    window.addEventListener('scroll', onScroll, true);
  }
  function closePop(silent, focusTo) {
    if (!P) return;
    var p = P; P = null;
    window.removeEventListener('scroll', onScroll, true);
    doc.documentElement.classList.remove('rkqa-lock');
    if (p.btn) p.btn.removeAttribute('aria-expanded');
    if (p.root.parentNode) p.root.parentNode.removeChild(p.root);
    if (silent) return;
    var to = focusTo || (p.btn && p.btn.isConnected ? p.btn : null) || doc.querySelector('#CartDrawer .drawer__inner');
    if (to) { try { to.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- 4 add (theme path: Section Rendering API + the cart drawer's own renderContents) ---------- */
  function setBtnText(b, t) {
    var n = b.firstChild;
    if (n && n.nodeType === 3) { if (b.__rkqaT == null) b.__rkqaT = n.nodeValue; n.nodeValue = t; }
  }
  function resetBtn(b) { var n = b.firstChild; if (n && n.nodeType === 3 && b.__rkqaT != null) n.nodeValue = b.__rkqaT; b.__rkqaT = null; }
  function addVariant(id, row, btn) {
    if (!id) return;
    var L = labels(row), drawer = doc.querySelector('cart-drawer'), go = P && P.panel.querySelector('[data-rkqa-go]'), target = go || btn;
    if (target.getAttribute('aria-busy') === 'true') return;
    var secs = ['cart-drawer', 'cart-icon-bubble'];
    try { if (drawer && typeof drawer.getSectionsToRender === 'function') secs = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    target.setAttribute('aria-busy', 'true');
    target.disabled = true;
    if (P) P.busy = true;
    setBtnText(target, L.adding);
    var msg = P && P.panel.querySelector('[data-rkqa-msg]');
    if (msg) msg.textContent = '';
    fetch(row.getAttribute('data-cart-add') || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: secs, sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { var e = new Error(j.description || j.message || L.error); e.rkCart = !!j.description; throw e; } return j; }); })
      .then(function (j) {
        var inDrawer = !!row.closest('cart-drawer');
        closePop(true);
        say(L.added);
        var done = false;
        if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
          try {
            drawer.classList.remove('is-empty');
            drawer.renderContents(j);
            done = true;
            if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open(inDrawer ? null : btn);
          } catch (e) {}
        }
        if (!done) { window.location.href = row.getAttribute('data-cart-url') || '/cart'; return; }
        if (inDrawer) { // the theme swaps the drawer HTML after this call: focus the new panel once it is in place, never leave focus on the page behind
          setTimeout(function () {
            var a = doc.activeElement, inner = doc.querySelector('#CartDrawer .drawer__inner');
            if (inner && (!a || a === doc.body || !a.isConnected || !inner.contains(a))) { try { inner.focus({ preventScroll: true }); } catch (e) {} }
          }, 150);
        }
        if (btn.isConnected) { target.removeAttribute('aria-busy'); target.disabled = false; resetBtn(target); }
      })
      .catch(function (err) {
        /* r55 FX4 (N1): a calm sentence for the shopper. Shopify's own cart answer (e.g. only N left) is already plain English and is kept;
           a network or parse failure ("Failed to fetch") shows the row's error label instead. The detail stays in the console. */
        try { console.warn('rk quick add failed:', err); } catch (e) {}
        var text = (err && err.rkCart && err.message) || L.error;
        target.removeAttribute('aria-busy');
        target.disabled = false;
        resetBtn(target);
        if (P) { P.busy = false; var m = P.panel.querySelector('[data-rkqa-msg]'); if (m) m.textContent = text; paint(); }
        else say(text);
      });
  }

  /* ---------- events (delegated: the drawer row is re-rendered on every cart change) ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (P && P.root.contains(t)) {
      if (t.closest('[data-rkqa-x]')) { e.preventDefault(); closePop(false); return; }
      var go = t.closest('[data-rkqa-go]');
      if (go && P.v && P.v.a) { e.preventDefault(); addVariant(P.v.id, P.row, P.btn); }
      return;
    }
    /* Phase 1 wash bag rewards (20 Oct 2026): inline cards (cart drawer and /cart) carry their colour swatches; a tap swaps the photo, price and
       the variant Add will send, and Add adds that variant at once (no pop-out). Markup: snippets/rk-qa-card.liquid (inline). */
    var sw = t.closest('[data-rkqa-sw]');
    if (sw && !sw.disabled) {
      e.preventDefault(); e.stopPropagation();
      var sc = sw.closest('[data-rkqa-card]'), sd = sc && data(sc), sv = sd && byId(sd, parseInt(sw.getAttribute('data-rkqa-sw'), 10));
      if (sv) { setPref(sc, sv); $$('[data-rkqa-sw]', sc).forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); }); }
      return;
    }
    var a = t.closest('[data-rkqa-add]');
    if (a && a.hasAttribute('data-rkqa-direct')) { e.preventDefault(); e.stopPropagation(); addVariant(parseInt(a.getAttribute('data-variant'), 10), a.closest('[data-rkqa-row]'), a); return; }
    if (a) { e.preventDefault(); e.stopPropagation(); openPop(a.closest('[data-rkqa-card]'), a); return; }
    var prev = t.closest('[data-rkqa-prev]'), next = t.closest('[data-rkqa-next]');
    if (prev || next) { e.preventDefault(); scrollRow((prev || next).closest('[data-rkqa-row]'), prev ? -1 : 1); }
  }, true);
  doc.addEventListener('change', function (e) {
    if (!P || !P.root.contains(e.target)) return;
    var inp = e.target; if (inp.type !== 'radio') return;
    P.sel = choose(P.d, P.sel, +inp.getAttribute('data-i'), inp.value);
    var m = P.panel.querySelector('[data-rkqa-msg]'); if (m) m.textContent = '';
    paint();
    var c = P.panel.querySelector('input[data-i="' + inp.getAttribute('data-i') + '"]:checked');
    if (c && c !== doc.activeElement) { try { c.focus({ preventScroll: true }); } catch (x) {} }
  });
  doc.addEventListener('keydown', function (e) {
    if (!P) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      swallowEsc = true; closePop(false); return;
    }
    if (e.key !== 'Tab') return;
    var list = tabbables(); if (!list.length) { e.preventDefault(); return; }
    var first = list[0], last = list[list.length - 1], a = doc.activeElement;
    if (!P.panel.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && (a === first || a === P.panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }, true);
  window.addEventListener('keyup', function (e) {
    if (swallowEsc && (e.key === 'Escape' || e.key === 'Esc')) { swallowEsc = false; e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  }, true);
  doc.addEventListener('focusin', function (e) {
    if (P && !P.root.contains(e.target)) { var f = P.panel.querySelector('input[type="radio"]:checked') || P.panel; try { f.focus({ preventScroll: true }); } catch (x) {} }
  });

  function boot() {
    scan(true);
    try { new MutationObserver(function (list) { for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length) { scanSoon(); return; } }).observe(doc.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  window.RKQA = { refresh: refresh, scan: scan, famOf: famOf, close: function () { closePop(false); } };
})();
